import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./add-organisation-config.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./add-organisation-config.component.scss?ngResource";
import { Component, Input, Output, EventEmitter } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { AlertType } from "../../../shared/models/alert";
import { HttpClient } from "@angular/common/http";
import { AppControllerService } from "../../../app-controller.service";
import { UserInformationService } from "../../../shared/services/user/user-information.service";
import { SharedConstants } from "../../../shared/constants/shared.constants";
import { LogValidatorErrors } from "../shared/log-validator-errors";
import { OrganisationConfigConstants } from "../organisation-config.constants";
import { AddOrganisationConstants } from "./add-organisation-config.constants";
import { ControlStatus, FormError, OrganisationDetailsConstants, ValidationMessage } from "../shared/organisation-details-form.constants";
import { ApiOrganisationConstants } from "../../../shared/constants/api-constants/api-organisation.constants";
import { CRUDOperation } from "../../../shared/models/crud-operation-enum.model";
import { map } from "rxjs/operators";
import { phoneNumberValidator } from "../../../shared/classes/phone-number-validator";
import { AppConfig } from "../../../app.config";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AutoUnsub } from "../../../shared/decorators/autounsub.decorator";
import { LookupConstants } from "../../../shared/constants/lookup.constants";
import { FileUploadService } from "../../../shared/services/file-upload/file-upload.service";
let AddOrganisationConfigComponent = class AddOrganisationConfigComponent {
    activeModal;
    fileUploadService;
    http;
    userInformationService;
    appController;
    modalTitle;
    existingOrganisations;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    addOrganisationForm;
    formHeader = AddOrganisationConstants.FORM_HEADER;
    nameTextPlaceHolder = OrganisationDetailsConstants.NAME_TEXT_PLACEHOLDER;
    sameAsStreetAddressAddress = OrganisationDetailsConstants.SAME_AS_ADDRESS;
    bankingDetailsHeaderPlaceHolder = OrganisationDetailsConstants.BANKING_DETAILS_HEADER_PLACEHOLDER;
    streetAddressHeaderPlaceHolder = OrganisationDetailsConstants.STREET_ADDRESS_HEADER_PLACEHOLDER;
    postalAddressHeaderPlaceHolder = OrganisationDetailsConstants.POSTAL_ADDRESS_HEADER_PLACEHOLDER;
    contactPersonTextPlaceHolder = OrganisationDetailsConstants.CONTACT_PERSON_TEXT_PLACEHOLDER;
    contactNumberTextPlaceHolder = OrganisationDetailsConstants.CONTACT_NUMBER_TEXT_PLACEHOLDER;
    alternativeNumberTextPlaceHolder = OrganisationDetailsConstants.ALTERNATIVE_NUMBER_TEXT_PLACEHOLDER;
    vatReferencePlaceHolder = OrganisationDetailsConstants.VAT_REFERENCE_TEXT_PLACEHOLDER;
    bankingDetailsTextPlaceHolder1 = OrganisationDetailsConstants.BANKING_DETAILS_1_TEXT_PLACEHOLDER;
    bankingDetailsTextPlaceHolder2 = OrganisationDetailsConstants.BANKING_DETAILS_2_TEXT_PLACEHOLDER;
    bankingDetailsTextPlaceHolder3 = OrganisationDetailsConstants.BANKING_DETAILS_3_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = OrganisationDetailsConstants.STREET_ADDRESS_TEXT_PLACEHOLDER;
    suburbTextPlaceHolder = OrganisationDetailsConstants.SUBURB_TEXT_PLACEHOLDER;
    cityTextPlaceHolder = OrganisationDetailsConstants.CITY_TEXT_PLACEHOLDER;
    provinceTextPlaceHolder = OrganisationDetailsConstants.PROVINCE_TEXT_PLACEHOLDER;
    codeTextPlaceHolder = OrganisationDetailsConstants.CODE_TEXT_PLACEHOLDER;
    postalATextPlaceHolder = OrganisationDetailsConstants.POSTAL_ADDRESS_TEXT_PLACEHOLDER;
    // form control names
    nameFormControl = OrganisationDetailsConstants.ORGANISATION_NAME_FORM_CONTROL;
    contactPersonFormControl = OrganisationDetailsConstants.CONTACT_PERSON_FORM_CONTROL;
    contactNumberFormControl = OrganisationDetailsConstants.CONTACT_NUMBER_FORM_CONTROL;
    alternativeNumberFormControl = OrganisationDetailsConstants.ALTERNATIVE_NUMBER_FORM_CONTROL;
    vatReferenceFormControl = OrganisationDetailsConstants.VAT_REFERENCE_FORM_CONTROL;
    bankingDetails1FormControl = OrganisationDetailsConstants.BANKING_DETAILS_1_FORM_CONTROL;
    bankingDetails2FormControl = OrganisationDetailsConstants.BANKING_DETAILS_2_FORM_CONTROL;
    bankingDetails3FormControl = OrganisationDetailsConstants.BANKING_DETAILS_3_FORM_CONTROL;
    streetAddressFormControl = OrganisationDetailsConstants.ADDRESS_FORM_CONTROL;
    streetSuburbFormControl = OrganisationDetailsConstants.SUBURB_FORM_CONTROL;
    streetCityFormControl = OrganisationDetailsConstants.CITY_FORM_CONTROL;
    streetProvinceFormControl = OrganisationDetailsConstants.PROVINCE_FORM_CONTROL;
    streetCodeFormControl = OrganisationDetailsConstants.CODE_FORM_CONTROL;
    postalAddressFormControl = OrganisationDetailsConstants.POSTAL_ADDRESS_FORM_CONTROL;
    postalSuburbFormControl = OrganisationDetailsConstants.POSTAL_SUBURB_FORM_CONTROL;
    postalCityFormControl = OrganisationDetailsConstants.POSTAL_CITY_FORM_CONTROL;
    postalProvinceFormControl = OrganisationDetailsConstants.POSTAL_PROVINCE_FORM_CONTROL;
    postalCodeFormControl = OrganisationDetailsConstants.POSTAL_CODE_FORM_CONTROL;
    sameAsStreetAddress = OrganisationDetailsConstants.SAME_AS_STREET_FORM_CONTROL;
    postalSimilarToStreetAddress = false;
    addressesSimilarClicked = new EventEmitter();
    provinceOptions = LookupConstants.PROVINCE;
    formErrors = FormError;
    logValidatorErrors = LogValidatorErrors;
    validationMessage = ValidationMessage;
    phoneNumberPattern = SharedConstants.PHONE_VALIDATOR_PATTERN;
    disablePostalAddressFields = ControlStatus;
    postalFormControls = [
        this.postalAddressFormControl,
        this.postalSuburbFormControl,
        this.postalCityFormControl,
        this.postalProvinceFormControl,
        this.postalCodeFormControl
    ];
    organisationNames = [];
    organisationUrl = ApiOrganisationConstants.URL;
    invalidFields = SharedConstants.FORM_NOT_VALID;
    uniqueNameMessage = AddOrganisationConstants.UNIQUE_NAME;
    saveSuccessMessage = SharedConstants.ADD_SUCCESS;
    errorObjectName = AddOrganisationConstants.ERROR_OBJECT_NAME;
    lookupErrorObjectName = AddOrganisationConstants.LOOKUP_ERROR_OBJECT_NAME;
    numberPattern = AddOrganisationConstants.NUMBER_VALIDATOR_PATTERN;
    cancelLabel = OrganisationConfigConstants.CANCEL_BUTTON_LABEL;
    createLabel = OrganisationConfigConstants.ADD_BUTTON_LABEL;
    organisationValue;
    maxFileSize = AppConfig.settings.uploadFile.maximumSize;
    allowedFiles = ["PNG", "JPE", "JPEG", "JPF", "JPG", "GIF"];
    organizationLogo = AddOrganisationConstants.ORGANIZATION_LOGO_FORM_CONTROL;
    formData;
    IOrganisationNamesValuesSubscription;
    IOrganisationSubscription;
    httpPostorganizationId;
    constructor(activeModal, fileUploadService, http, userInformationService, appController) {
        this.activeModal = activeModal;
        this.fileUploadService = fileUploadService;
        this.http = http;
        this.userInformationService = userInformationService;
        this.appController = appController;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
        this.initForm();
    }
    ngOnInit() {
        this.getOrganisationNames();
    }
    initForm() {
        this.addOrganisationForm = new FormGroup({
            name: new FormControl(null, [Validators.required, Validators.maxLength(150)]),
            contactPerson: new FormControl(null, [Validators.required, Validators.maxLength(150)]),
            contactNumber: new FormControl(null, [Validators.required, phoneNumberValidator]),
            alternativeNumber: new FormControl(null, phoneNumberValidator),
            vatReference: new FormControl(null, [Validators.required, Validators.maxLength(50)]),
            bankingDetails1: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
            bankingDetails2: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
            bankingDetails3: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
            streetAddress: new FormControl(null, [Validators.required, Validators.maxLength(150)]),
            streetSuburb: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
            streetCity: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
            streetProvince: new FormControl(null, Validators.required),
            streetCode: new FormControl(null, [Validators.required, Validators.pattern(RegExp(/[0-9]{4}$/))]),
            postalAddress: new FormControl(null, [Validators.required, Validators.maxLength(150)]),
            postalSuburb: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
            postalCity: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
            postalProvince: new FormControl(null, Validators.required),
            postalCode: new FormControl(null, [Validators.required, Validators.pattern(RegExp(/[0-9]{4}$/))])
        });
    }
    updatedAddresses(updateAddress) {
        this.postalSimilarToStreetAddress = updateAddress;
    }
    onResidentialInputEntered(event, formControlName) {
        if (this.postalSimilarToStreetAddress) {
            const input = event.target.value;
            const postalFormControl = this.addOrganisationForm.get(formControlName);
            postalFormControl.setValue(input);
        }
    }
    disableOrEnableControls(controls, status) {
        Object.keys(this.addOrganisationForm.controls).forEach(key => {
            if (controls.indexOf(key) >= 0) {
                switch (status) {
                    case ControlStatus.enable:
                        this.enablePostalFields(key);
                        break;
                    case ControlStatus.disable:
                        this.disablePostalFields(key);
                        break;
                }
            }
            this.addOrganisationForm.controls[key].updateValueAndValidity();
        });
    }
    enablePostalFields(key) {
        this.addOrganisationForm.controls[key].enable();
        this.addOrganisationForm.controls[key].setValidators(Validators.required);
        if (key === this.postalCodeFormControl)
            this.addOrganisationForm.controls[key].setValidators([Validators.pattern(this.phoneNumberPattern),
                Validators.minLength(4), Validators.required]);
    }
    disablePostalFields(key) {
        this.addOrganisationForm.controls[key].clearValidators();
        this.addOrganisationForm.controls[key].reset();
        this.copyStreetAddressData();
        this.addOrganisationForm.controls[key].disable();
    }
    copyStreetAddressData() {
        this.addOrganisationForm.get(this.postalAddressFormControl).setValue(this.addOrganisationForm.get(this.streetAddressFormControl).value);
        this.addOrganisationForm.get(this.postalSuburbFormControl).setValue(this.addOrganisationForm.get(this.streetSuburbFormControl).value);
        this.addOrganisationForm.get(this.postalCityFormControl).setValue(this.addOrganisationForm.get(this.streetCityFormControl).value);
        this.addOrganisationForm.get(this.postalProvinceFormControl).setValue(this.addOrganisationForm.get(this.streetProvinceFormControl).value);
        this.addOrganisationForm.get(this.postalCodeFormControl).setValue(this.addOrganisationForm.get(this.streetCodeFormControl).value);
    }
    copyStreetAddress(event) {
        const checkBoxStatus = event.target.checked;
        this.postalSimilarToStreetAddress = checkBoxStatus;
        if (this.postalSimilarToStreetAddress) {
            this.disableOrEnableControls(this.postalFormControls, this.disablePostalAddressFields.disable);
        }
        else {
            this.disableOrEnableControls(this.postalFormControls, this.disablePostalAddressFields.enable);
        }
        this.addOrganisationForm.updateValueAndValidity();
        this.addressesSimilarClicked.emit(this.postalSimilarToStreetAddress);
    }
    getOrganisationNames() {
        const params = { $select: `name` };
        this.IOrganisationNamesValuesSubscription =
            this.http.get(this.organisationUrl, { params })
                .pipe(map(organisationNamesValues => organisationNamesValues.value)).subscribe((response) => {
                this.organisationNames = [...response];
            }, error => this.appController.handleServerErrorMessage(this.lookupErrorObjectName, error, CRUDOperation.Get));
    }
    createOrganisation() {
        this.userInformationService.showDisclaimerAfterCreateOrganisation = false;
        if (this.addOrganisationForm.invalid) {
            this.appController.showMessage(this.invalidFields, AlertType.Warning);
            return;
        }
        this.organisationValue = { ...this.addOrganisationForm.value };
        if (this.postalSimilarToStreetAddress) {
            const { streetAddress, streetCity, streetCode, streetProvince, streetSuburb } = this.organisationValue;
            this.organisationValue = {
                ...this.organisationValue,
                postalAddress: streetAddress,
                postalCity: streetCity,
                postalCode: streetCode,
                postalProvince: streetProvince,
                postalSuburb: streetSuburb
            };
        }
        if (this.isNameUnique(this.organisationValue.name)) {
            this.appController.showMessage(`${this.uniqueNameMessage} ${this.organisationValue.name} already exist`, AlertType.Warning);
            return;
        }
        this.IOrganisationSubscription = this.http.post(this.organisationUrl, this.organisationValue)
            .subscribe({
            next: (org) => {
                if (!this.formData) {
                    this.updateUserData();
                    this.appController.showMessage(this.saveSuccessMessage, AlertType.Success);
                    this.userInformationService.showDisclaimerAfterCreateOrganisation = false;
                    this.activeModal.close(true);
                }
                if (this.formData)
                    this.uploadOrganizationLogo(org.id);
            }, error: error => {
                this.appController.handleServerErrorMessage(this.errorObjectName, error, CRUDOperation.Add);
            }
        });
    }
    updateUserData() {
        this.userInformationService.getUserInformation();
    }
    uploadOrganizationLogo(organizationId) {
        const url = `${this.organisationUrl}/${organizationId}/${ApiOrganisationConstants.FUNCTION_UPLOAD_LOGO}`;
        this.fileUploadService.uploadFile(url, this.formData, "Municipal", "default", null, false, (result) => {
            if (result !== null) {
                this.updateUserData();
                this.appController.showMessage(this.saveSuccessMessage, AlertType.Success);
                this.activeModal.close(true);
            }
        });
    }
    isNameUnique(orgName) {
        const isNameUnique = this.organisationNames?.some(organisationName => organisationName.name.toLowerCase().trim() === orgName.toLowerCase().trim());
        return isNameUnique;
    }
    uploadFile(file) {
        this.formData = new FormData();
        this.formData.append("Invoice", file, file.name);
    }
    onDeleteFile(index) {
        const fileExist = this.formData.has("file");
        if (fileExist) {
            this.formData.delete("file");
        }
    }
    updateAddresses() {
    }
    onBtnSaveClicked() {
        this.createOrganisation();
    }
    onBtnCancelClicked() {
        this.activeModal.close();
    }
    static ctorParameters = () => [
        { type: NgbActiveModal },
        { type: FileUploadService },
        { type: HttpClient },
        { type: UserInformationService },
        { type: AppControllerService }
    ];
    static propDecorators = {
        modalTitle: [{ type: Input }],
        existingOrganisations: [{ type: Input }],
        addressesSimilarClicked: [{ type: Output }]
    };
};
AddOrganisationConfigComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-add-organisation-config",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], AddOrganisationConfigComponent);
export { AddOrganisationConfigComponent };
